require('./areas-new-container.scss')

module.exports = {
  template: require('./areas-new-container.pug')()
  controller: require('./areas-new-container.ctrl')
  bindings:
    country: '<'
    city: '<'
}
